<template>
    <div class="containerInner">
        <div class="productListHeader">
            <div class="headerLeftMenu">
                <span>商品マスタ</span>
            </div>
            <div class="headerRightMenu">
                <span class="dispAdMenu mr" @click="showSelectProduct">
                    <span class="productName">{{ selectedTargetName }}</span>
                </span>
            </div>
        </div>

        <div class="api-logs">
            <table>
                <thead>
                    <tr>
                        <th>商品ID</th>
                        <th>商品名</th>
                        <th>価格（税抜）</th>
                        <th>原価</th>
                        <th>原価率</th>
                        <th>原価更新日</th>
                        <th>初回売上日</th>
                        <th>備考</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="product in productLists" :key="product.id">
                        <td>{{ product.id }}<Icon v-if="product.is_set_product" title="セット商品">
                                dice-multiple-outline</Icon>
                        </td>
                        <td>{{ product.name }}</td>
                        <td class="ta-r">{{ product.price | priceLocaleString }}</td>
                        <td class="ta-r">{{ product.product_cost | priceLocaleString }}</td>
                        <td class="ta-r">{{ getCostRate(product.price, product.product_cost) }}%</td>
                        <td class="ta-c">{{ product.cost_change_at }}</td>
                        <td class="ta-c">{{ orderedAt(product.ordered_at) }}</td>
                        <td>{{ product.bikou }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
        <modal name="selectProduct" :draggable="false" :resizable="false" width="85%" height="90%">
            <ShowProduct modal-type="productMaster" @modalClosed="selectProductModalClosed"
                v-model="inputSelectedTarget" />
        </modal>
    </div>
</template>

<script>
import ShowProduct from './ShowProduct.vue';
import _ from 'lodash';

export default {
    components: {
        ShowProduct,
    },
    data() {
        return {
            statusMessage: "",
            productLists: [],
            selectedTarget: {
                type: 'single',
                product: { id: -1, name: '全商品', },
                totallingTarget: { id: null, name: null, products: null },
            },
        }
    },
    mounted: function () {
        // GETパラメータで表示条件を指定している場合
        const qProductId = this.$route.query.productId ?? null;
        const qTargetId = this.$route.query.targetId ?? null;
        const qProductName = this.$route.query.productName ?? null;

        // 単体商品ID
        if (qProductId !== null) {
            this.selectedTarget.type = "single";
            this.selectedTarget.product.id = qProductId;
            this.selectedTarget.product.name = qProductName;
        }
        // 商品グループID
        if (qTargetId !== null) {
            this.selectedTarget.type = "totalling";
            this.selectedTarget.totallingTarget.id = qTargetId;
            this.selectedTarget.totallingTarget.name = qProductName;
        }

        this.$watch(
            function () {
                this.fetchProductDetail(this.selectedTarget.type, this.selectedTarget.product.id, this.selectedTarget.totallingTarget.id);
            }
        )
    },
    methods: {
        fetchProductDetail(type, product_id, totallingTarget_id) {
            let url = '';
            let target = '';

            if (type === "single") {
                if (product_id === -1) {
                    //全商品の商品情報取得
                    url = "/api/products/detail";
                }
                else {
                    //単一商品の商品情報取得
                    url = "/api/products/detail/single";
                    target = product_id;
                }
            }
            else {
                //グループ商品の商品情報取得
                url = "/api/products/detail/totalling";
                target = totallingTarget_id;
            }

            this.$store.dispatch("loading", true);
            this.axios.get(url, {
                params: {
                    targetId: target,
                }
            })
                .then((res) => {
                    this.productLists = _.map(res.data, product => {
                        return product;
                    });
                    this.$store.dispatch("loading", false);
                });
        },
        getCostRate(price, product_cost) {
            var cost_rate = 0;
            if (price != 0) {
                cost_rate = Math.round(product_cost / price * 100);
            }
            return cost_rate;
        },
        orderedAt(ordered_at) {
            if (ordered_at == "") {
                return "実績なし";
            }
            return ordered_at;
        },
        showSelectProduct() {
            this.modalShow = true
            this.$modal.show('selectProduct')
        },
        selectProductModalClosed() {
            this.modalShow = false
            this.$modal.hide('selectProduct')
        },
    },
    computed: {
        selectedTargetName: function () {
            const typeName = (() => {
                switch (this.selectedTarget.type) {
                    case 'single':
                        return '単品';
                    case 'totalling':
                        return 'グループ';
                    default:
                        return '';
                }
            })();
            const targetName = (() => {
                switch (this.selectedTarget.type) {
                    case 'single':
                        return '【' + this.selectedTarget.product.id + '】' + this.selectedTarget.product.name;
                    case 'totalling': {
                        const name = this.selectedTarget.totallingTarget.name ?? "";
                        return name;
                    }
                    default:
                        return '';
                }
            })() ?? '';
            // 全商品の場合
            if (this.selectedTarget.type == 'single' && this.selectedTarget.product.id === -1) {
                return this.selectedTarget.product.name;
            }
            return `${typeName}：${targetName}`;
        },
        inputSelectedTarget: {
            get: function () { return this.selectedTarget; },
            set: function (selectedTarget) {
                this.selectedTarget = selectedTarget;
            },
        },
    }
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .productListHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 360px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                #unregistered
                    display: none
                .unregisteredCheckBox
                    line-height: 18px
                    padding-left: 25px
                    position: relative
                    &::before
                        background: $whiteColor
                        border: 1px solid $grayColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 15px
                        position: absolute
                        width: 15px
                    &::after
                        border-bottom: 3px solid $mainColor
                        border-right: 3px solid $mainColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 9px
                        left: 5px
                        margin-top: -8px
                        opacity: 0
                        position: absolute
                        top: 50%
                        transform: rotate(45deg)
                        width: 5px
                #unregistered:checked + .unregisteredCheckBox::after
                    opacity: 1
        .headerRightMenu
            flex: 1 0 auto
            .dispAdMenu
            background: $mainColor
            color: $whiteColor
            cursor: pointer
            overflow: hidden
            padding: 7px
            position: relative
            width: 350px
            &::before
                background: $whiteColor
                top: 0
                content: ''
                height: 100%
                left: 0
                position: absolute
                transform: translate(0%, 100%)
                transition: all .3s ease-in-out
                width: 100%
            &::after
                background: $whiteColor
                content: ''
                height: 16px
                position: absolute
                right: 8px
                transform: rotate(45deg)
                transition: all .3s ease-in-out
                top: 6px
                width: 16px
            &:hover
                color: $grayColor
                &::before
                    transform: translate(0%, 0%)
                &::after
                    background: $grayColor
                    transform: rotate(225deg)
            .productName
                display: block
                position: relative
    .api-logs
        max-height: 85%
        overflow: auto
        margin: 10px 140px 0 140px
        font-size: 1.5rem
        table
            width: 100%
            thead
                background-color: $mainColor
                color: $whiteColor
                position: sticky
                top: 0
                z-index: 2
                &:before
                    border-bottom: 3px solid $grayColor
                    content: ""
                    position: absolute
                    top: -24px
                    left: 0px
                    width: 100%
                    height: 100%
                th
                    padding: 3px 6px
                    border: solid 2px $grayColor
                    white-space: nowrap
            tbody
                background-color: $whiteColor
                td
                    border: solid 2px $grayColor
                    padding: 10px 5px
                    white-space: nowrap
                .ta-c
                    text-align: center
                .ta-r
                    text-align: right
    .productListFooter
        margin: 20px 140px 0 140px
        position: relative
        .pageDisp
            font-size: 1.3rem
            line-height: 42px
            right: 15px
            position: absolute
            top: 50%
    .loadingWindow
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .productListHeader
            display: block
            margin: 0 0 0 10px
            .headerRightMenu
                margin-top: 10px
        .api-logs
            margin: 0 0 30px 10px
</style>
